// category slider


$(document).ready(function ($) {
	$(".owl-cat").owlCarousel({
		loop: false,
		margin: 10,
		dots: true,
		nav: true,
		items: 3
	});
	var owl = $(".owl-carousel.owl-cat");
	owl.owlCarousel();
	$(".next-btn").click(function () {
		owl.trigger("next.owl.carousel");
	});
	$(".prev-btn").click(function () {
		owl.trigger("prev.owl.carousel");
	});
	$(".prev-btn").addClass("disabled");
	$(owl).on("translated.owl.carousel", function (event) {
		if ($(".owl-prev").hasClass("disabled")) {
			$(".prev-btn").addClass("disabled");
		} else {
			$(".prev-btn").removeClass("disabled");
		}
		if ($(".owl-next").hasClass("disabled")) {
			$(".next-btn").addClass("disabled");
		} else {
			$(".next-btn").removeClass("disabled");
		}
	});
});

// popular slider

$(document).ready(function ($) {
	$(".owl-pop").owlCarousel({
		loop: false,
		margin: 10,
		dots: true,
		nav: true,
		items: 1,
		responsiveClass:true,
		responsive:{
			0:{
				items:1,
			},
			500:{
				items:2,
			},
			991:{
				items:3,
			},
			1440:{
				items:4,
			}
		}
	});
	var owl = $(".owl-carousel.owl-pop");
	owl.owlCarousel();
	$(".owl-pop .next-btn").click(function () {
		owl.trigger("next.owl.carousel");
	});
	$(".owl-pop .prev-btn").click(function () {
		owl.trigger("prev.owl.carousel");
	});
	$(".owl-pop .prev-btn").addClass("disabled");
	$(owl).on("translated.owl.carousel", function (event) {
		if ($(".owl-prev").hasClass("disabled")) {
			$(".prev-btn").addClass("disabled");
		} else {
			$(".prev-btn").removeClass("disabled");
		}
		if ($(".owl-next").hasClass("disabled")) {
			$(".next-btn").addClass("disabled");
		} else {
			$(".next-btn").removeClass("disabled");
		}
	});
});

// review slider


$(document).ready(function ($) {
  if($(window).innerWidth() < 768) {
	$(".owl-review").owlCarousel({
		loop: true,
		margin: 10,
		dots: true,
		nav: true,
		items: 4,
        autoplay:true,
        autoplayTimeout: 3000,
        smartSpeed: 800,
		responsive:{
			0:{
				items:1
			},
			500:{
				items:2,
                autoplay:true
			},
			991:{
				items:3
			},
			1440:{
				items:4
			}
		}
	});
  }else{
    $(".owl-review").owlCarousel({
		loop: true,
		margin: 10,
		dots: true,
		nav: true,
		items: 4,
        autoplay:false,
        autoplayTimeout: 3000,
        smartSpeed: 800,
		responsive:{
			0:{
				items:1
			},
			500:{
				items:2,
                autoplay:true
			},
			991:{
				items:3
			},
			1440:{
				items:4
			}
		}
	});
  }
	var owl = $(".owl-carousel.owl-review");
	owl.owlCarousel();
	$(".owl-review .next-btn").click(function () {
		owl.trigger("next.owl.carousel");
	});
	$(".owl-review .prev-btn").click(function () {
		owl.trigger("prev.owl.carousel");
	});
	$(".owl-review .prev-btn").addClass("disabled");
	$(owl).on("translated.owl.carousel", function (event) {
		if ($(".owl-prev").hasClass("disabled")) {
			$(".prev-btn").addClass("disabled");
		} else {
			$(".prev-btn").removeClass("disabled");
		}
		if ($(".owl-next").hasClass("disabled")) {
			$(".next-btn").addClass("disabled");
		} else {
			$(".next-btn").removeClass("disabled");
		}
	});
});

// blog slider

$(document).ready(function ($) {
	$(".owl-blog").owlCarousel({
		loop: false,
		margin: 10,
		dots: true,
		nav: true,
		items: 3,
		responsive:{
			0:{
				items:1
			},
			500:{
				items:2
			},
			991:{
				items:3
			},
			1440:{
				items:3
			}
		}
	});
	var owl = $(".owl-carousel.owl-blog");
	owl.owlCarousel();
	$(".owl-blog .next-btn").click(function () {
		owl.trigger("next.owl.carousel");
	});
	$(".owl-blog .prev-btn").click(function () {
		owl.trigger("prev.owl.carousel");
	});
	$(".owl-blog .prev-btn").addClass("disabled");
	$(owl).on("translated.owl.carousel", function (event) {
		if ($(".owl-prev").hasClass("disabled")) {
			$(".prev-btn").addClass("disabled");
		} else {
			$(".prev-btn").removeClass("disabled");
		}
		if ($(".owl-next").hasClass("disabled")) {
			$(".next-btn").addClass("disabled");
		} else {
			$(".next-btn").removeClass("disabled");
		}
	});
});$(document).ready(function ($) {
	$(".owl-blog").owlCarousel({
		loop: false,
		margin: 10,
		dots: true,
		nav: true,
		items: 3,
		responsive:{
			0:{
				items:1
			},
			500:{
				items:2
			},
			991:{
				items:3
			},
			1440:{
				items:3
			}
		}
	});
	var owl = $(".owl-carousel.owl-blog");
	owl.owlCarousel();
	$(".owl-blog .next-btn").click(function () {
		owl.trigger("next.owl.carousel");
	});
	$(".owl-blog .prev-btn").click(function () {
		owl.trigger("prev.owl.carousel");
	});
	$(".owl-blog .prev-btn").addClass("disabled");
	$(owl).on("translated.owl.carousel", function (event) {
		if ($(".owl-prev").hasClass("disabled")) {
			$(".prev-btn").addClass("disabled");
		} else {
			$(".prev-btn").removeClass("disabled");
		}
		if ($(".owl-next").hasClass("disabled")) {
			$(".next-btn").addClass("disabled");
		} else {
			$(".next-btn").removeClass("disabled");
		}
	});
});


// intr slider

$(document).ready(function (){
	var swiper = new Swiper('.swiper', {
		slidesPerView: 2.5,
		centeredSlides: false,
		loop: true,
		spaceBetween: 20,
		pagination: {
		  el: '.swiper-pagination',
		  clickable: true,
		  renderBullet: function (index, className) {
			return '<span class="' + className + '"></span>';
		  },
		},
		navigation: {
		  nextEl: '.swiper-button-next',
		  prevEl: '.swiper-button-prev',
		},
		
		breakpoints: {
			0: {
			  slidesPerView: 1,
			  spaceBetween: 20
			},
			575: {
			  slidesPerView: 1.5,
			  spaceBetween: 20
			},
			991: {
			  slidesPerView: 2.5,
			  spaceBetween: 20
			}
		  }
	});

});
  
// plus minus counter

// $(document).ready(function() {
// 	$('.minus').click(function () {
// 		var $input = $(this).parent().find('input');
// 		var count = parseInt($input.val()) - 1;
// 		count = count < 1 ? 1 : count;
// 		$input.val(count);
// 		$input.change();
// 		return false;
// 	});
// 	$('.plus').click(function () {
// 		var $input = $(this).parent().find('input');
// 		$input.val(parseInt($input.val()) + 1);
// 		$input.change();
// 		return false;
// 	});
// });

// look box slider

$(document).ready(function ($) {
	$(".owl-look-box").owlCarousel({
		loop: false,
		margin: 10,
		dots: true,
		nav: true,
		items: 2
	});
	var owl = $(".owl-carousel.owl-look-box");
	owl.owlCarousel();
	$(".owl-look-box .next-btn").click(function () {
		owl.trigger("next.owl.carousel");
	});
	$(".owl-look-box .prev-btn").click(function () {
		owl.trigger("prev.owl.carousel");
	});
	$(".owl-look-box .prev-btn").addClass("disabled");
	$(owl).on("translated.owl.carousel", function (event) {
		if ($(".owl-prev").hasClass("disabled")) {
			$(".prev-btn").addClass("disabled");
		} else {
			$(".prev-btn").removeClass("disabled");
		}
		if ($(".owl-next").hasClass("disabled")) {
			$(".next-btn").addClass("disabled");
		} else {
			$(".next-btn").removeClass("disabled");
		}
	});
});


// // product thumbanail slider

// $(document).ready(function() {  
// 	/*********************
// 		 Thumbnails slider
// 	*********************/
// // Change the main image whenever a thumbnail button is activated
// $('.thumbnails-slider').on('init', function(e, slider) {
// 	$(slider.$slides.find('.thumbnail-button')).each(function(index) {
// 		$(this).on('click', function() {
// 		// Move aria-current="true" to this button
// 		$(slider.$slides.find('.thumbnail-button').removeAttr('aria-current'));
// 		$(this).attr('aria-current', true);

// 		// Change the main image to match this thumbnail button
// 		var index = $(this).closest('.slick-slide').data('slick-index');
// 		$('.main-image-slider').slick('slickGoTo', index);
// 		});
// 	});




// });
// 	// Initialize the slider
// 	$('.thumbnails-slider').slick({
// 		vertical: true,
// 		slidesToShow: 4,
// 		infinite: false,
// 		arrows: false,
// 		instructionsText: 'This carousel contains a column of small thumbnails. Selecting a thumbnail will change the main image in the carousel that follows. Use the Previous and Next buttons to cycle through all the thumbnails, use Enter to select.',
// 		regionLabel: 'thumbnails carousel',
// 		responsive: [
// 		{
// 		breakpoint: 1200,
// 		settings: {
// 			vertical: false,
// 			horizontal: true,
// 			slidesToShow: 4,
// 		}
// 		}
// 	]

// 	});


// 	/********************
// 		 Main image slider
// 	*********************/
// 	$('.main-image-slider').slick({
// 		slidesToShow: 1,
// 		slidesToScroll: 1,
// 		draggable: true,
// 		arrows: true,
// 		instructionsText: 'This carousel shows one large product image at a time. Use the Previous and Next buttons to move between images, or use the preceding thumbnails carousel to select a specific image to display here.',
// 		regionLabel: 'main image carousel',
// 	});

// 	// Update the thumbnail slider when the user changes the main slider directly.
// 	$('.main-image-slider').on('beforeChange', function(e, slider, currentSlide, nextSlide) {
// 	// Remove aria-current from the last selected thumbnail image button
// 	$('.thumbnails-slider .thumbnail-button[aria-current="true"]').removeAttr('aria-current');
	
// 	// Select the thumbnail image button that goes with this main image. Most importantly, this updates Slick's internal state to be consistent with the visual change.
// 	$('.thumbnails-slider').slick('slickGoTo', nextSlide);

// 	// Add aria-current="true" to the correct thumbnail image button to convey to screen readers that it's active.
// 	$('.thumbnails-slider .thumbnail-button:eq(' + nextSlide + ')').attr('aria-current', true);
// 	}); 

	
// });



// var $table = document.querySelector('.cm-group');

// $table.addEventListener("click", function(ev){
//   if (ev.target.tagName == "INPUT") {
//     if (ev.target.checked) {
//       ev.target.parentNode.parentNode.classList.add("selected");
//     }else {
//       ev.target.parentNode.parentNode.classList.remove("selected");
//     }
//   }
// });



// $(function() {
//     $( "#slider-range" ).slider({
//       range: true,
//       min: 200,
//       max: 1000,
//       step: 100
//       ,
//       values: [ 0, 1000 ],
//       slide: function( event, ui ) {
//         $( "#min_amount" ).html( "Min Prijs: <label>" + ui.values[ 0 ]+"</label>");
//         $( "#max_amount" ).html( "  Max Prijs:<label>" + ui.values[ 1 ]+ "</label>");
//     }
// });
// $( "#min_amount" ).html( "Min Prijs:<label>" + $( "#slider-range" ).slider( "values", 0 )+"</label>" );
// $( "#max_amount" ).html( "  Max Prijs:<label>" + $( "#slider-range" ).slider( "values", 1 )+"</label>" );
//     // $( "#amount" ).val( "Min Prijs:" + $( "#slider-range" ).slider( "values", 0 ) +
//     //   "  Max Prijs:" + $( "#slider-range" ).slider( "values", 1 ) );
// });


// Blog slider


$(document).ready(function ($) {
	$(".owl-Nieuwste").owlCarousel({
		loop: false,
		margin: 10,
		dots: true,
		nav: true,
		items: 2
	});
	var owl = $(".owl-carousel.owl-Nieuwste");
	owl.owlCarousel();
	$(".owl-Nieuwste .next-btn").click(function () {
		owl.trigger("next.owl.carousel");
	});
	$(".owl-Nieuwste .prev-btn").click(function () {
		owl.trigger("prev.owl.carousel");
	});
	$(".owl-Nieuwste .prev-btn").addClass("disabled");
	$(owl).on("translated.owl.carousel", function (event) {
		if ($(".owl-prev").hasClass("disabled")) {
			$(".prev-btn").addClass("disabled");
		} else {
			$(".prev-btn").removeClass("disabled");
		}
		if ($(".owl-next").hasClass("disabled")) {
			$(".next-btn").addClass("disabled");
		} else {
			$(".next-btn").removeClass("disabled");
		}
	});
});


// mobile header

$(".toggle-menu figure").click(function(){
	$(".mobile-header").addClass("open");
});

$(".ms-top .close").click(function(){
	$(".mobile-header").removeClass("open");
});

$(".ms-bottom li span").click(function(){
	$(".mobile-sidebar").addClass("sub-menu");
});

$(".back-menu").click(function(){
	$(".mobile-sidebar").removeClass("sub-menu");
});



$(document).on("click", function(e){        
	if( 
		$(e.target).closest(".hmenu").length == 0 &&
		$(".hmenu").hasClass("open") &&
		$(e.target).closest(".menu-btn").length == 0
	)
	{
		$('.hmenu').toggleClass('open');
	}
});

$(".filter").click(function(){
	$(".shop-fold").addClass("filter-open");
});
$(".shop-filter .close").click(function(){
	$(".shop-fold").removeClass("filter-open");
});
$("header li span").click(function(){
	$(".mh-menubar").toggleClass("inner-menu");
});

$(".header-cart, .mobilecart").click(function(){
	$(".cart-drwaer").addClass("cdopen");
	$("body").addClass("cart");
});

$(".closebtn").click(function(){
	$(".cart-drwaer").removeClass("cdopen");
	$("body").removeClass("cart");
});



// POP POPUP MODEL
(function($) {
    "use strict";
        $(document).ready(function() {
                $('.pd-above .main-image-slider .slick-list.draggable').on('click', function() {
                  var data_media_id = $(this).find(".slick-slide.slick-current.slick-active .image-link").attr("data-media-id");
                  
                  // console.log(data_media_id);
                $('body').addClass("modal-open");
                  setTimeout(function(){
                    var position = $('#custom-modal .custom-modal-inner img[data-media-id="'+data_media_id+'"]').offset().top - 80;
                       $("#custom-modal").animate({ 
                          scrollTop: position 
                      }, 10);
                    // console.log($('#custom-modal .custom-modal-inner img[data-media-id="'+data_media_id+'"]').offset().top+" => "+position);
                  },500);
            });
            $('.close-modal').on('click', function() {
                $('body').removeClass("modal-open");
            });
        });
}(jQuery));